import {ORDER_METHODS, RoomServiceLocationType} from "../../../../../services/exports/Constants";

export default {
  more_info: 'More info',
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: '{{time}} min room service',
      [RoomServiceLocationType.TableService]: '{{time}} min table service',
      both: '{{time}} min room/table service',
    },
    [ORDER_METHODS.PICKUP]: '{{time}} min pickup',
    [ORDER_METHODS.DELIVERY]: '{{time}} min delivery',
  },
  labels: {
    available: 'Available',
    unavailable: 'Unavailable',
  },
  buttons: {
    change_store: 'Change store',
  },
};
